import { addDays } from 'date-fns'
import type { VFC } from 'react'
import { kuiperClassNames } from '@opallabs/kuiper'
import { WeekViewDayHeader } from '../WeekViewDayHeader'
import * as styles from './styles'
import type { DayHeadersProps, onUpdateMomentCallback } from './types'

export type { onUpdateMomentCallback }

export const DayHeaders: VFC<DayHeadersProps> = ({
  onUpdateMoment,
  start,
  theme = 'light',
}) => (
  <div
    className={kuiperClassNames('weekViewDaysHeader')}
    css={styles.container({ theme })}
  >
    {new Array(7).fill({}).map((_, index) => (
      <WeekViewDayHeader
        date={addDays(start, index)}
        key={index}
        onUpdateMoment={onUpdateMoment}
        theme={theme}
      />
    ))}
  </div>
)
DayHeaders.displayName = 'Continuum: DayHeaders ← WeekView'
